import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-booking-details-popover',
  templateUrl: './booking-details-popover.component.html',
  styleUrls: ['./booking-details-popover.component.scss']
})
export class BookingDetailsPopoverComponent implements OnInit {

  @Input() singleBookingDetails: any;
  @Output() closeBookingDetailsCallback = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  handleCloseBookingDetails() {
    if (this.closeBookingDetailsCallback) {
      this.closeBookingDetailsCallback.emit();
    }
  }

}
